import {
  requestType,
  succeedType,
  failedType,
  GET_METADATA,
  RESET_METADATA,
} from "./../actions/actionTypes";

const initState = {
  meta_data: {},
  is_fetching: false,
};

export const metadataReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(GET_METADATA):
      return {
        ...state,
        is_fetching: true,
      };
    case succeedType(GET_METADATA):
      return {
        ...state,
        is_fetching: false,
        meta_data: action.meta_data,
      };
    case failedType(GET_METADATA):
      return {
        ...state,
        is_fetching: false,
      };
    case RESET_METADATA:
      return {
        ...state,
        meta_data: {},
      };
    default:
      return state;
  }
};
